module.exports = __webpack_public_path__ + "static/media/Photo - Azetnio-Rami Roukoss.60d6d2de.jpg";